import { lazy, Suspense } from "react"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"

import { Admin } from "@/App/Admin"
import { Analytics } from "@/App/Analytics"
import { NewRfq } from "@/App/Credit"
import { LiveRates } from "@/App/LiveRates"
import { TornOutTileWrapper } from "@/App/LiveRates/Tile"
import { TornOut } from "@/App/TearOutSection/TearOutWrapper"
import { CreditTrades, FxTrades } from "@/App/Trades"
import { DisconnectionOverlay } from "@/components/DisconnectionOverlay"
import { Loader } from "@/components/Loader"
import { BASE_PATH, ROUTES_CONFIG } from "@/constants"
import { isMobileDevice } from "@/utils"
import { FEATURE_FLAG, useFeature } from "@/utils/featureFlag"

import { CreditPage } from "./CreditPage"
import { EquitiesRoutes } from "./EquitiesRoutes"
import { FxPage } from "./FxPage"
import { MainLayout } from "./MainLayout"

const SellSidePage = lazy(() => import("./SellSidePage"))
const StyleguidePage = lazy(() => import("../styleguide/Styleguide"))

export const App = () => {
  const canUseAdmin = useFeature(FEATURE_FLAG.ADMIN)

  return (
    <BrowserRouter
      basename={BASE_PATH}
      future={{
        v7_relativeSplatPath: false,
        v7_startTransition: false,
      }}
    >
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route
            path="/"
            element={
              <>
                <DisconnectionOverlay />
                <FxPage />
              </>
            }
          />
          {!isMobileDevice && (
            <Route
              path={ROUTES_CONFIG.credit}
              element={
                <>
                  <DisconnectionOverlay />
                  <CreditPage />
                </>
              }
            />
          )}
          <Route path={ROUTES_CONFIG.equities} element={<EquitiesRoutes />} />
        </Route>

        {!isMobileDevice && (
          <Route
            path={ROUTES_CONFIG.sellSide}
            element={
              <Suspense fallback={<Loader />}>
                <DisconnectionOverlay />
                <SellSidePage />
              </Suspense>
            }
          />
        )}
        {!isMobileDevice && (
          <Route
            path={ROUTES_CONFIG.newRfq}
            element={
              <TornOut>
                <NewRfq />
              </TornOut>
            }
          />
        )}
        {!isMobileDevice && (
          <Route
            path={ROUTES_CONFIG.creditBlotter}
            element={
              <TornOut>
                <CreditTrades />
              </TornOut>
            }
          />
        )}
        <Route path={ROUTES_CONFIG.tile} element={<TornOutTileWrapper />} />

        <Route
          path={ROUTES_CONFIG.styleguide}
          element={
            <Suspense fallback={<Loader />}>
              <StyleguidePage />
            </Suspense>
          }
        />

        {canUseAdmin && (
          <Route path={ROUTES_CONFIG.admin} element={<Admin />} />
        )}

        <Route
          path={ROUTES_CONFIG.tiles}
          element={
            <TornOut>
              <LiveRates />
            </TornOut>
          }
        />
        <Route
          path={ROUTES_CONFIG.blotter}
          element={
            <TornOut>
              <FxTrades />
            </TornOut>
          }
        />
        <Route
          path={ROUTES_CONFIG.analytics}
          element={
            <TornOut>
              <Analytics />
            </TornOut>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  )
}
